import { PhoneAuthForm } from './PhoneAuthForm';

interface Props {
  onGoRegister: () => void;
  onSuccess: () => void;
}

export function PhoneLoginScreen({ onGoRegister, onSuccess }: Props) {
  return (
    <PhoneAuthForm variant="login" onSwitchVariant={onGoRegister} onSuccess={onSuccess} />
  );
}
